/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Card, { CardHeader, CardContent } from '../Card';
import CircularProgress from '../Progress';
import Typography from '../Typography';
import styles from './styles';
var ChartWrapper = function (_a) {
    var _b = _a.chartWrapper, chartData = _b.chartData, _c = _b.chartHighlight, chartHighlight = _c === void 0 ? undefined : _c, chartLoading = _b.chartLoading, _d = _b.chartSubtitle, chartSubtitle = _d === void 0 ? '' : _d, chartTitle = _b.chartTitle, _e = _b.noDataText, noDataText = _e === void 0 ? '' : _e, _f = _a.children, children = _f === void 0 ? undefined : _f;
    var classes = styles();
    return (React.createElement(Card, { elevation: 1 },
        React.createElement(CardHeader, { title: chartTitle, subheader: !!chartSubtitle && chartSubtitle }),
        React.createElement(CardContent, null,
            !chartLoading && !!chartHighlight && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { align: "left", className: classes.highlight, display: "inline", variant: "h4" }, chartHighlight.value),
                React.createElement(Typography, { align: "left", color: "textSecondary", display: "inline", variant: "body1" }, chartHighlight.description))),
            chartLoading && (React.createElement("div", { className: classes.loadingBox },
                React.createElement(CircularProgress, null))),
            !chartLoading && chartData.length === 0 && (React.createElement(Typography, { align: "center", color: "textSecondary", variant: "body1" }, noDataText)),
            !chartLoading && chartData.length > 0 && React.createElement("div", { className: classes.chart }, children))));
};
export default ChartWrapper;
//# sourceMappingURL=ChartWrapper.js.map